import { I18n } from '@calendly/i18n';
import { TimeClockCircleIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { timeNotationSelector } from 'selectors/current_user';
import { parseTime } from 'services/time_format';
import { summarizeInterval } from 'shared/utils';
const daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const dayContainerIsEmptyCss = "d1cebxpw";
const dayContainerCss = "d1en3zku";
const DayContainer = forwardRef((props, ref) => {
  const {
    isEmpty,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dayContainerCss, {
    [dayContainerIsEmptyCss]: isEmpty
  }, props.className)} />;
});
const availabilitySummaryContainerCss = "a71bqay";
const AvailabilitySummaryContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(availabilitySummaryContainerCss, props.className)} />;
});
const processAvailabilityRules = (availabilityRules, timeNotation) => {
  const rulesObject = availabilityRules.reduce((acc, rule) => {
    if (!acc[rule.wday]) {
      acc[rule.wday] = [];
    }
    rule.intervals.forEach(interval => {
      const summary = summarizeInterval({
        from: parseTime(interval.from, '24h'),
        to: parseTime(interval.to, '24h')
      }, timeNotation);
      acc[rule.wday].push(summary);
    });
    return acc;
  }, {});
  return daysOfTheWeek.map(day => {
    const isEmpty = !rulesObject[day] || rulesObject[day].length === 0;
    return {
      day,
      summary: !isEmpty ? rulesObject[day].join(', ') : I18n.t('publisher.meetings.time_options.none'),
      isEmpty
    };
  });
};
export const AvailabilitySummary = ({
  availabilityRules
}) => {
  const timeNotation = useSelector(timeNotationSelector);
  const dayNames = I18n.t('date.day_names_hash');
  const processedRules = useMemo(() => processAvailabilityRules(availabilityRules, timeNotation), [availabilityRules, timeNotation]);
  return <AvailabilitySummaryContainer>
      {processedRules.map(({
      day,
      summary,
      isEmpty
    }) => <DayContainer key={day} isEmpty={isEmpty}>
          <TimeClockCircleIcon />
          <BodyText weight="bold">{dayNames[day]}</BodyText>
          <div>
            {isEmpty ? <BodyText color="muted">{summary}</BodyText> : summary}
          </div>
        </DayContainer>)}
    </AvailabilitySummaryContainer>;
};

require("./availability_summary.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./availability_summary.js");